var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRustBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 106,
    width: 106,
    style: {
      filter: "invert(1)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(53, 53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r",
    transform: "translate(0.5, 0.5)",
    stroke: "black",
    strokeWidth: 1,
    strokeLinejoin: "round",
    d: "     M -9,-15 H 4 C 12,-15 12,-7 4,-7 H -9 Z     M -40,22 H 0 V 11 H -9 V 3 H 1 C 12,3 6,22 15,22 H 40     V 3 H 34 V 5 C 34,13 25,12 24,7 C 23,2 19,-2 18,-2 C 33,-10 24,-26 12,-26 H -35     V -15 H -25 V 11 H -40 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gear",
    mask: "url(#holes)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 43,
    fill: "none",
    stroke: "black",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "cogs"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "cog",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round",
    points: "46,3 51,0 46,-3"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(11.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(22.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(33.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(45.00)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(56.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(67.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(78.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(90.00)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(101.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(112.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(123.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(135.00)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(146.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(157.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(168.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(180.00)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(191.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(202.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(213.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(225.00)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(236.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(247.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(258.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(270.00)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(281.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(292.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(303.75)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(315.00)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(326.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(337.50)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cog",
    transform: "rotate(348.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mounts"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "mount",
    stroke: "black",
    strokeWidth: 6,
    strokeLinejoin: "round",
    points: "-7,-42 0,-35 7,-42"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mount",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mount",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mount",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mount",
    transform: "rotate(288)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "holes"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -60,
    width: 120,
    height: 120,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "hole",
    cy: -40,
    r: 3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hole",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hole",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hole",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hole",
    transform: "rotate(288)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRustBadge);
export default __webpack_public_path__ + "static/media/rust-badge.951429296e3501b490cfdf1840137ae6.svg";
export { ForwardRef as ReactComponent };